import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import {
    authLinks,
    creatorMenu,
    myStuffMenu,
    myStuffApiMenu,
    myAccountMenu,
    adminMenu
} from "../../data/links";

import { GrayButton } from "../shared";
import { Heading, Section, Item, Link, Div } from "./index";

const Teams = ({ teams, onTeamClick }) => {
    const result = teams.length ? (
        <Section>
            {teams.map(team => (
                <Item key={team.username}>
                    <Link
                        onClick={onTeamClick}
                        href={`/${team.username}/settings/seats/`}
                    >
                        {team.name}
                    </Link>
                </Item>
            ))}
        </Section>
    ) : null;

    return result;
};

Teams.propTypes = {
    teams: PropTypes.array
};

let Content = ({ className, user, logOut, closeMenu, isHeroSearchV2 }) => {
    user = user || {};
    user.ownedTeams = user.ownedTeams || {};

    const getLinks = ({ linkData }) =>
        linkData.map(link => (
            <Item key={link.name}>
                <Link
                    onClick={closeMenu}
                    href={
                        typeof link.href === "string"
                            ? link.href
                            : link.href({ username: user.username })
                    }
                    target={link.external ? "_blank" : "_self"}
                >
                    {typeof link.name === "string"
                        ? link.name
                        : link.name({
                              hasNotifications: user.hasNotifications
                          })}
                </Link>
            </Item>
        ));

    const creatorMenuLinks = getLinks({ linkData: creatorMenu });
    const myStuffMenuLinks = getLinks({ linkData: myStuffMenu });
    const myStuffApiMenuLinks = getLinks({ linkData: myStuffApiMenu });
    const myAccountMenuLinks = getLinks({ linkData: myAccountMenu });
    const adminMenuLinks = getLinks({ linkData: adminMenu });

    return (
        <Div className={className} isHeroSearchV2={isHeroSearchV2}>
            {user.isCreator && (
                <Section>
                    <Heading>Creator</Heading>
                    {creatorMenuLinks}
                </Section>
            )}
            <Section>
                <Heading>My Stuff</Heading>
                {myStuffMenuLinks}
                {user.hasApiKey && myStuffApiMenuLinks}
            </Section>
            <Section>
                <Heading>My Account</Heading>
                {myAccountMenuLinks}
                {!!user.ownedTeams.length && (
                    <Item>
                        <p>Manage Team:</p>
                        <Teams
                            onTeamClick={closeMenu}
                            teams={user.ownedTeams}
                        />
                    </Item>
                )}
            </Section>
            {user.isSuperuser && (
                <Section>
                    <Heading>Admin</Heading>
                    {adminMenuLinks}
                </Section>
            )}
            <Div style={{ textAlign: "center", marginTop: "1.625rem" }}>
                <GrayButton size="medium" width="8.5625rem" onClick={logOut}>
                    {authLinks.logout.text}
                </GrayButton>
            </Div>
        </Div>
    );
};

Content = styled(Content)``;

Content.propTypes = {
    user: PropTypes.object,
    logout: PropTypes.func,
    closeMenu: PropTypes.func,
    isHeroSearchV2: PropTypes.bool
};

export { Content };
